<template>


  <div class="row equal">


    <div class="leftside col-md-7">
      <div class="col-md-offset-4 col-md-8">

        <checkout-breadcrumb/>

        <div ref="checkoutPaymentInfo" class="row equal"></div>


        <form method="POST" id="payment-form" :action="route">
          <input name="total_cost" type="hidden" :value="calculatedTotalCost">

          <div v-if="term" class="form-group" :class="{'has-error' : consentError}">
            <label class="control-label">
              <input v-model="consent" type="checkbox">
              {{ __('webapp.i_have_read_and_agreed_with') }} <a @click.prevent="showTermModal = true"
                                                                href="#">{{ term.name }}</a>
            </label>

            <modal
                @close="showTermModal = false"
                @submit="submitTermModal"
                :show="showTermModal"
                size="lg"
            >
              <template slot="header">{{ term.name }}</template>
              <div v-html="term.value"></div>
            </modal>

          </div>

          <!-- PAYPAL -->
          <div v-if="type == 'paypal'">
            <input type="hidden" name="paypal_authorization_id" id="paypal-authorization-id">
            <paypal-form
                :total="totalCost"
                @success="onPaypalSuccess"
                @error="onPaypalError"
            />


            <input name="paypal_authorization_id" type="hidden" :value="paypalAuthorizationId">

          </div>

          <!-- VIVA WALLET -->
          <div v-if="type == 'vivawallet'" style="display: flex; flex-direction: column; align-items: center">
            <img style="max-width: 200px" src="/assets/images/Viva-logo.png" alt="vivawallet-logo">
            <span style="margin-bottom: 10px">{{__t('shop.redirect_to_vivawallet')}}</span>
            <button class="btn btn-block shop-button is-btn-primary eshop-payment-button">{{__t('shop.continue_to_payment')}}</button>
          </div>

          <!-- STRIPE -->
          <div v-if="type == 'stripe'">
            <stripe-form
                :fullname="fullname"
                :email="email"
                :amount="totalCost"
                @submit="handleStripeSubmit"
            />

            <input name="stripe_payment_intent_id" type="hidden" :value="stripePaymentIntentId">

          </div>

          <div v-if="type === 'offline'">
            <button :disabled="!canSubmit" @click.prevent="handleSubmitButton"
                    class="btn btn-block shop-button is-btn-primary eshop-payment-button">
              <i class="fas fa-receipt"></i> {{ __t('shop.checkout.submit_order') }}
            </button>
          </div>

          <div v-if="type === 'alphabank' || type == 'winbank' || type == 'eurobank'">
            <button :disabled="!canSubmit" @click.prevent="handleSubmitButton"
                    class="btn btn-block shop-button is-btn-primary eshop-payment-button">
              <i class="fas fa-receipt"></i> {{ __t('shop.checkout.submit_payment') }}
            </button>
          </div>

          <div v-if="type == 'ethniki'">
            <button :disabled="!canSubmit" @click.prevent="handleSubmitButton"
                    class="btn btn-block shop-button is-btn-primary eshop-payment-button">
              <i class="fas fa-receipt"></i> {{ __t('shop.checkout.submit_payment') }}
            </button>
          </div>
        </form>
      </div>

    </div>

    <div class="rightside col-md-5">
      <div class="col-md-8">

       <div style="margin-bottom: 32px;display: flex;justify-content:flex-start;align-items: center">
          <i style="color:#1ABA75" class="fal fa-3x fa-bags-shopping"></i>
          <p style="margin-left: 24px">{{ __t('shop.cart.your_cart_has_x_products',{x: $_.sumBy(cart.items,(i) => Number(i.quantity)) }) }}</p>
        </div>

        <cart-table :cart="cart" :total-items-cost="cart.cart_after_discount_cost"
          :total-discount="cart.cart_cost - cart.cart_after_discount_cost" :default-vat="defaultVat"
          :b2b-enabled="b2bEnabled" @vat-total="updateVatTotal" />


        <div class="text-right">
          <div v-if="cart.shipping_method_cost > 0">
            {{ cart.shipping_method_name }}: {{ cart.shipping_method_cost }} {{ currency }}
          </div>
          <div v-if="cart.payment_method_cost > 0">
            {{ cart.payment_method_name }}: {{ cart.payment_method_cost }} {{ currency }}
          </div>
          <div >
            <hr class="col-md-6 col-md-offset-5 " style="margin-top:30px;margin-bottom:5px" />
            <div class="cart-order-total">{{ __('webapp.order_total') }}: {{ totalCost}} {{ currency }}</div>
            <div  class="cart-vat-included" > {{ __('webapp.taxes_included') }} </div>
          </div>
        </div>


      </div>
    </div>
  </div>


</template>
<script>

import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';

import PaypalForm from '@/components/common/paypal-form';
import StripeForm from '@/components/common/stripe-form';

import WinbankForm from '@/components/common/winbank-form';
import checkoutBreadcrumb from './eshop-checkout-breadcumb';
import CartTable from './common/cart-table'


import modal from '@/components/ui/modal';


export default {
  components: {
    PaypalForm,
    StripeForm,
    WinbankForm,
    modal,
    checkoutBreadcrumb,
    CartTable
  },
  data: function () {
    return {
      currency: window.currency,
      consentError: false,
      showTermModal: false,
      term: null,
      consent: false,
      alias: window.company_alias,
      paypalAuthorizationId: null,
      stripePaymentIntentId: null,
      vatTotal: 0,
    }
  },
  props: {
    fullname: String,
    email: String,
    totalCost: [String, Number],
    route: String,
    environment: String,
    type: String,
    defaultVat: {
      type: Object,
      default: null
    },
    b2bEnabled: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapGetters({cart: 'getCart'}),
    canSubmit() {
      return true;
    },
   
    calculatedTotalCost() {
      var cost = Number(this.cart.total_cost);
      if (!this.b2bEnabled) {
        cost += parseFloat(this.vatTotal);
      }
      return cost.toFixed(2);

    },
  },
  created() {
    var self = this;
    $.ajax({
      url: route('webapp.ordering.shop-terms', this.alias),
      success(response) {
        self.term = response.data;
      },
      error(err) {
        // no terms
        self.consent = true;
      }
    });
    this.initCart(this.alias);
  },
  mounted(){
    $(this.$refs.checkoutPaymentInfo).append($('#checkout-payment-info').html());
  },
  methods: {
    ...mapActions([
      'clearCart',
      'initCart',
    ]),
    submitTermModal() {
      this.consent = true;
      this.showTermModal = false;
    },
    handleStripeSubmit(id) {
      this.stripePaymentIntentId = id;
      this.submit();
    },
    onPaypalSuccess(authorizationId) {
      this.paypalAuthorizationId = authorizationId;
      this.submit();
    },
    onPaypalError(err) {
      toastr.error(err);
    },
    handleSubmitButton() {
      if (!this.consent) {
        this.consentError = true;
        return;
      }

      this.submit();

    },
    updateVatTotal(vatTotal) {
      console.log(vatTotal);
      this.vatTotal = vatTotal;
    },
    submit() {
      this.$nextTick(() => {
        $("#payment-form").submit();
        // this.clearCart().then(_ => {});
      });
    }
  }

}
</script>

<style>
  .cart-order-total {
    font-weight:bold ;
    font-size: 21px;

  }

</style>
